module.exports = __webpack_public_path__ + "img/retro1.c389e054.png";